import { apolloClient } from "@services"

const authService = {
  clearToken: () => window.localStorage.removeItem("adminToken"),
  clearApolloCache: () => apolloClient.clearStore(),
  getToken: () => window.localStorage.getItem("adminToken"),

  isAuthenticated: () => window.localStorage.getItem("adminToken") !== null,

  login: token => {
    authService.setToken(token)
  },

  logout: (redirect = "/") => {
    authService.clearToken()
    authService.clearApolloCache()
    window.location.replace(redirect)
  },

  setClarityUser: (user) => {
    if (!window.clarity) return

    if (user) {
      window.clarity("consent");
      window.clarity("identify", user?.me?.id || "unknown");
      window.clarity("set", "user_id", user?.me?.id || "unknown");
      window.clarity("set", "client_id", user?.me?.client?.id || "unknown");
      window.clarity("set", "role_id", user?.clientUserRoles?.id || "unknown");
    }
  },

  setToken: token => window.localStorage.setItem("adminToken", token),
}

export default authService
